import { useContext } from 'react';
import { AppContext } from '../../context/Contexte';
export default function Table({ result }) {
  const { t } = useContext(AppContext);
  return (
    <>
      {result && (
        <table className="table ResultTable">
          <thead>
            <tr>
              <td> </td>
              <td> {t('gout_of_day')} </td>
              <td> {t('delaide_text')} </td>
            </tr>
          </thead>
          <tbody>
            <tr
              className={
                recommandedOil(result)?.oil === result.cbd5 ? 'Recommanded' : ''
              }
            >
              <td>
                <a href="https://www.sowelab.com/collections/huile-cbd/products/lhuile-cbd-5-10-ml-500mg">
                  {t('oil')} CBD 5%
                </a>
              </td>
              <td> {result.cbd5} </td>
              <td> {result.cbd5 === 0 ? 0 : Math.round(200 / result.cbd5)} </td>
            </tr>

            <tr
              className={
                recommandedOil(result)?.oil === result.cbd10
                  ? 'Recommanded'
                  : ''
              }
            >
              <td>
                <a href="https://www.sowelab.com/collections/huile-cbd/products/lhuile-cbd-10">
                  {t('oil')} CBD 10%
                </a>
              </td>
              <td> {result.cbd10} </td>
              <td>{result.cbd5 === 0 ? 0 : Math.round(200 / result.cbd10)}</td>
            </tr>

            <tr
              className={
                recommandedOil(result)?.oil === result.cbd15
                  ? 'Recommanded'
                  : ''
              }
            >
              <td>
                <a href="https://www.sowelab.com/collections/huile-cbd/products/lhuile-cbd-15">
                  {t('oil')} CBD 15%
                </a>
              </td>
              <td> {result.cbd15} </td>
              <td>{result.cbd5 === 0 ? 0 : Math.round(200 / result.cbd15)}</td>
            </tr>

            <tr
              className={
                recommandedOil(result)?.oil === result.cbd20
                  ? 'Recommanded'
                  : ''
              }
            >
              <td>
                <a href="https://www.sowelab.com/collections/huile-cbd/products/lhuile-cbd-20">
                  {t('oil')} CBD 20%
                </a>
              </td>
              <td> {result.cbd20} </td>
              <td>{result.cbd5 === 0 ? 0 : Math.round(200 / result.cbd20)}</td>
            </tr>

            <tr
              className={
                recommandedOil(result)?.oil === result.cbd30
                  ? 'Recommanded'
                  : ''
              }
            >
              <td>
                <a href="https://www.sowelab.com/collections/huile-cbd/products/lhuile-cbd-30">
                  {t('oil')} CBD 30%
                </a>
              </td>
              <td> {result.cbd30} </td>
              <td>{result.cbd5 === 0 ? 0 : Math.round(200 / result.cbd30)}</td>
            </tr>
          </tbody>
        </table>
      )}
    </>
  );
}

const recommandedOil = (result) => {
  const oils = [
    {
      oil: result.cbd5,
      days: result.cbd5 === 0 ? 0 : Math.round(200 / result.cbd5),
    },
    {
      oil: result.cbd10,
      days: result.cbd5 === 0 ? 0 : Math.round(200 / result.cbd10),
    },
    {
      oil: result.cbd15,
      days: result.cbd5 === 0 ? 0 : Math.round(200 / result.cbd15),
    },
    {
      oil: result.cbd20,
      days: result.cbd5 === 0 ? 0 : Math.round(200 / result.cbd20),
    },
    {
      oil: result.cbd30,
      days: result.cbd5 === 0 ? 0 : Math.round(200 / result.cbd30),
    },
  ];
  const response = [];
  for (const oil of oils) {
    response.push({
      oil: oil.oil,
      days: oil.days,
      calculate: Math.abs(oil.days - 30),
    });
  }
  const min = Math.min(...response.map((item) => item.calculate));
  return response.find((item) => item.calculate === min);
};
